import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <path d="M15.99 13.204l-.002-.005a.664.664 0 00-.076-.195.662.662 0 00-.105-.143l-1.667-1.666a.667.667 0 00-.943.942l.529.53h-1.724V8.665a.667.667 0 00-1.334 0v4H9.335V6a.667.667 0 00-1.334 0v6.667H6.668V9.332a.667.667 0 00-1.334 0v3.334h-2V2.274l.529.529a.664.664 0 00.942 0 .667.667 0 000-.943L3.138.193c-.01-.01-.02-.017-.031-.026a.654.654 0 00-.18-.116c-.002 0-.003-.002-.005-.003h-.001a.658.658 0 00-.213-.046.665.665 0 00-.17.008l-.01.004a.67.67 0 00-.191.074.646.646 0 00-.142.105L.528 1.86a.667.667 0 00.943.943l.53-.529v10.392H.666a.667.667 0 000 1.334H2v1.333a.667.667 0 001.334 0V14h10.392l-.529.528a.667.667 0 00.943.943l1.667-1.667c.01-.01.016-.021.026-.031a.712.712 0 00.115-.18l.004-.005v-.001a.663.663 0 00.046-.212.662.662 0 00-.008-.171z"></path>
        </svg>
    );
}